/**
 * Product Modal - Opens product detail pages in a full-screen overlay
 * Prevents 404s by loading product content from pre-rendered sections on the page.
 */
(function () {
  'use strict';

  var modal = null;
  var overlay = null;

  function createModal() {
    overlay = document.createElement('div');
    overlay.className = 'pd-modal-overlay';
    overlay.addEventListener('click', closeModal);
    document.body.appendChild(overlay);

    modal = document.createElement('div');
    modal.className = 'pd-modal';
    modal.setAttribute('role', 'dialog');
    modal.setAttribute('aria-modal', 'true');
    modal.setAttribute('aria-label', 'Product details');
    document.body.appendChild(modal);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) {
        closeModal();
      }
    });
  }

  function openModal(productSlug) {
    var section = document.querySelector('[data-pd-section="' + productSlug + '"]');
    if (!section) return;

    // Clone the section content into the modal
    modal.innerHTML = '';
    var closeBtn = document.createElement('button');
    closeBtn.className = 'pd-modal__close-inner';
    closeBtn.setAttribute('aria-label', 'Close');
    closeBtn.innerHTML = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>';
    closeBtn.addEventListener('click', closeModal);
    modal.appendChild(closeBtn);

    var content = section.cloneNode(true);
    content.style.display = '';
    content.removeAttribute('data-pd-section');
    modal.appendChild(content);

    // Show modal
    modal.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    // Re-initialize the product detail JS on the cloned content
    initProductPage(modal.querySelector('[data-pd-page]'));
  }

  function closeModal() {
    if (modal) modal.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    document.documentElement.style.overflow = '';
    // Clean up auto-play intervals
    if (modal) modal.innerHTML = '';
  }

  function initProductPage(page) {
    if (!page) return;

    var track = page.querySelector('[data-pd-track]');
    var slides = page.querySelectorAll('[data-pd-slide]');
    var dots = page.querySelectorAll('[data-pd-dot]');
    var thumbs = page.querySelectorAll('[data-pd-thumb]');
    var sizeButtons = page.querySelectorAll('[data-pd-size]');
    var priceEl = page.querySelector('[data-pd-price]');
    var qtyInput = page.querySelector('[data-pd-qty]');
    var qtyMinus = page.querySelector('[data-pd-qty-minus]');
    var qtyPlus = page.querySelector('[data-pd-qty-plus]');
    var addBtn = page.querySelector('[data-pd-add]');
    var accordionItems = page.querySelectorAll('[data-pd-accordion]');
    var wishBtn = page.querySelector('[data-pd-wishlist]');

    var currentSlide = 0;
    var totalSlides = slides.length;
    var autoPlayInterval = null;

    // Gallery
    function goToSlide(idx) {
      if (idx < 0) idx = totalSlides - 1;
      if (idx >= totalSlides) idx = 0;
      currentSlide = idx;
      track.style.transform = 'translateX(-' + (currentSlide * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === currentSlide); });
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === currentSlide); });
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () { goToSlide(i); resetAutoPlay(); });
    });
    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goToSlide(i); resetAutoPlay(); });
    });

    function startAutoPlay() {
      autoPlayInterval = setInterval(function () { goToSlide(currentSlide + 1); }, 3000);
    }
    function resetAutoPlay() { clearInterval(autoPlayInterval); startAutoPlay(); }
    startAutoPlay();

    // Size selection
    sizeButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        sizeButtons.forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        var price = btn.getAttribute('data-pd-size-price');
        if (price && priceEl) priceEl.textContent = price;
      });
    });

    // Quantity
    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', function () {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
    }

    // Add to Bag
    if (addBtn) {
      addBtn.addEventListener('click', function () {
        var productName = page.getAttribute('data-pd-product-name') || 'Product';
        var selectedSize = page.querySelector('[data-pd-size].is-selected');
        var size = selectedSize ? selectedSize.textContent.trim() : '';
        var qty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;
        var price = priceEl ? priceEl.textContent.trim() : '';
        var image = slides[0] ? slides[0].querySelector('img').getAttribute('src') : '';

        var item = {
          id: productName.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-' + size.toLowerCase().replace(/[^a-z0-9]+/g, '-'),
          name: productName,
          size: size,
          qty: qty,
          price: price,
          image: image
        };

        addBtn.textContent = 'ADDED ✓';
        addBtn.style.background = '#1a1a1a';
        addBtn.style.color = '#ffffff';

        if (window.PNCart && window.PNCart.add) {
          window.PNCart.add(item);
        }

        setTimeout(function () {
          addBtn.textContent = 'ADD TO BAG';
          addBtn.style.background = '';
          addBtn.style.color = '';
        }, 2000);
      });
    }

    // Accordions
    accordionItems.forEach(function (item) {
      var trigger = item.querySelector('[data-pd-accordion-trigger]');
      var content = item.querySelector('[data-pd-accordion-content]');
      trigger.addEventListener('click', function () {
        var isOpen = item.classList.contains('is-open');
        accordionItems.forEach(function (a) {
          a.classList.remove('is-open');
          a.querySelector('[data-pd-accordion-content]').style.maxHeight = '0';
        });
        if (!isOpen) {
          item.classList.add('is-open');
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });

    // Wishlist
    if (wishBtn) {
      var productId = wishBtn.getAttribute('data-pd-wishlist-id');
      if (window.PNFavorites && window.PNFavorites.isFavorited(productId)) {
        wishBtn.classList.add('is-favorited');
      }
      wishBtn.addEventListener('click', function () {
        if (!window.PNFavorites) return;
        if (window.PNFavorites.isFavorited(productId)) {
          window.PNFavorites.remove(productId);
          wishBtn.classList.remove('is-favorited');
        } else {
          var productName = page.getAttribute('data-pd-product-name') || 'Product';
          var image = slides[0] ? slides[0].querySelector('img').getAttribute('src') : '';
          var price = priceEl ? priceEl.textContent.trim() : '';
          window.PNFavorites.add({
            id: productId,
            title: productName,
            subtitle: '',
            price: price,
            image: image,
            url: '#'
          });
          wishBtn.classList.add('is-favorited');
        }
        window.PNFavorites.refresh();
      });
    }
  }

  // Intercept product link clicks
  function bindProductLinks() {
    document.querySelectorAll('[data-product-link]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var slug = link.getAttribute('data-product-link');
        openModal(slug);
      });
    });
  }

  // Init
  function init() {
    createModal();
    bindProductLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  window.PNProductModal = {
    open: openModal,
    close: closeModal
  };
})();
